"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment = require("moment");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var PriceFormulas_1 = require("../../../core/model/math/PriceFormulas");

var ReleaseState_1 = require("../ReleaseState");
/**
 * <p>This entity encapsulates data to build sellout identification detailed report. <b>Name of entity is a little misleading.</b></p>
 *
 * @author Adam Drda
 */


var RepriceableItemReleaseProjectionDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(RepriceableItemReleaseProjectionDTO, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param releaseId {@link SelloutReleaseItem.releaseId} associated with an item
   * @param productId {@link SelloutReleaseItem.productId} associated with an item
   * @param siteId {@link SelloutReleaseItem.siteId} associated with an item
   * @param endDate {@link SelloutReleaseItem.endDate} of an item
   * @param endDateFinalPrice {@link FinalProductPrice.validTo} of {@link SelloutReleaseItemPrices} of an item
   * @param purchasePrice {@link SelloutReleaseItemPrices.purchasePrice purchase price value} of an item
   * @param selloutPrice {@link SelloutReleaseItemPrices.finalPrice amount of final price} of an item TODO Should not we use rounded value instead?
   * @param releaseName {@link SelloutRelease.name} of associated release to which an item belongs
   * @param releaseState {@link SelloutRelease.state} of associated release to which an item belongs
   * @param estimationInPercent {@link SelloutReleaseItemEvaluation.estimationInPercent} of an item
   * @param availableSupply {@link SelloutReleaseItemSupplyData.availableSupply}
   * @param amount {@link SelloutReleaseItemSupplyData.amount}, can be null because of both missing supplyData of an item, or amount
   */
  function RepriceableItemReleaseProjectionDTO(releaseId, productId, siteId, endDate, endDateFinalPrice, purchasePrice, selloutPrice, releaseName, releaseState, estimationInPercent, availableSupply, amount) {
    var _this;

    _classCallCheck(this, RepriceableItemReleaseProjectionDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RepriceableItemReleaseProjectionDTO).call(this));
    _this.releaseId = releaseId;
    _this.productId = productId;
    _this.siteId = siteId;
    _this.endDate = endDate;
    _this.endDateFinalPrice = endDateFinalPrice;
    _this.purchasePrice = purchasePrice;
    _this.selloutPrice = selloutPrice;
    _this.releaseName = releaseName;
    _this.releaseState = releaseState;
    _this.estimationInPercent = estimationInPercent;
    _this.availableSupply = availableSupply;
    _this.amount = amount;
    return _this;
  }
  /**
   * @returns stock amount on site, that should be sold out
   */


  _createClass(RepriceableItemReleaseProjectionDTO, [{
    key: "getStockAmount",
    value: function getStockAmount() {
      return this.amount !== null ? this.amount : this.availableSupply;
    }
    /**
     * @returns calculation stock value as {@link #purchasePrice} * {@link #getStockAmount}, if any operand is null, result is null
     */

  }, {
    key: "getStockValue",
    value: function getStockValue() {
      var stockAmount = this.getStockAmount();
      return !this.purchasePrice || !stockAmount ? null : this.purchasePrice.mul(stockAmount.value);
    }
    /**
     * @returns number of days left to the {@link #getEndDate} as requested within LOG-5046
     */

  }, {
    key: "getDaysLeft",
    value: function getDaysLeft() {
      var resolvedEndDate = this.getEndDate();

      if (!resolvedEndDate) {
        return 0;
      }

      return PriceFormulas_1.PriceFormulas.computeDaysInPriceInterval(moment(), resolvedEndDate, Number.MAX_VALUE);
    }
    /**
     * @returns end date (if {@link #endDateFinalPrice} is filled, it is returned, otherwise {@link #endDate} is returned instead
     */

  }, {
    key: "getEndDate",
    value: function getEndDate() {
      return this.endDateFinalPrice !== null ? this.endDateFinalPrice : this.endDate;
    }
  }]);

  return RepriceableItemReleaseProjectionDTO;
}(DomainObject_1.DomainObject);

exports.RepriceableItemReleaseProjectionDTO = RepriceableItemReleaseProjectionDTO;

RepriceableItemReleaseProjectionDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(RepriceableItemReleaseProjectionDTO.name);
  return {
    releaseId: builder.str('releaseId'),
    productId: builder.str('productId'),
    siteId: builder.str('siteId'),
    endDate: builder.opt(builder.date('endDate')),
    endDateFinalPrice: builder.opt(builder.date('endDateFinalPrice')),
    purchasePrice: builder.opt(builder.bigNum('purchasePrice')),
    selloutPrice: builder.opt(builder.bigNum('selloutPrice')),
    releaseName: builder.opt(builder.str('releaseName')),
    releaseState: builder.opt(builder.senum('releaseState', ReleaseState_1.ReleaseState, 'enums/ReleaseState')),
    estimationInPercent: builder.opt(builder.bigNum('estimationInPercent')),
    availableSupply: builder.opt(builder.data('availableSupply', {
      value: builder.bigNum('value'),
      unitId: builder.str('unitId')
    })),
    amount: builder.opt(builder.data('amount', {
      value: builder.bigNum('value'),
      unitId: builder.str('unitId')
    }))
  };
}();